export default {
  screenTwoList: [
    {
      title: '签',
      direction: require('@/assets/images/landing-contractmanage/down.png'),
      num: '99%',
      text: '合同签署时间降低99%',
      desc: ['异地秒签免邮寄', '电子合同签署快至1分钟', '批量签署上千份合同', '签字和实名信息实时校验', '模板编辑使用权限实时管控'],
    },
    {
      title: '审',
      direction: require('@/assets/images/landing-contractmanage/up.png'),
      num: '95%',
      text: '合同审批及协同效率提升',
      desc: [
        '内置多级审批引擎，',
        '可快速灵活部署多级审批',
        '用印嵌入自研智能比对能力，',
        '0.5秒在线比对OA审批终稿和用印文件',
        '无需对接仍可保证签审不断档',
      ],
    },
    {
      title: '管',
      direction: require('@/assets/images/landing-contractmanage/up.png'),
      num: '99%',
      text: '合同管理效率提升',
      desc: [
        '企业合同智能化分类归档',
        '集团化管理方案在线管控分子公司',
        '智能获取业务数据自动形成业务台账',
        '低成本api方案业务数据可回传业务系统',
      ],
    },
    {
      title: '控',
      direction: require('@/assets/images/landing-contractmanage/up.png'),
      num: '98%',
      text: '合同签管风控提升',
      desc: ['人事合同薪资在线保密避免泄露', '授权体系的印章管理', '相对方风险在线批量监控', '蚂蚁区块链全流程上链构建完整证据链条'],
    },
  ],
  screenFourTabTitle: ['人事场景', '分销场景'],
  screenFourTabContent: [
    {
      td: {
        title: '人事痛点',
        content: [
          {
            key: 1,
            desc: '员工信息收集及建档难',
          },
          {
            key: 2,
            desc: '分子公司异地签约效率低',
          },
          {
            key: 3,
            desc: '员工签约进度难追踪',
          },
          {
            key: 4,
            desc: '员工信息和薪资不能泄露',
          },
        ],
      },
      fa: {
        title: '人事解决方案',
        text: '基于人事场景为企业提供如下能力，助力企业人事场景入转调离高效流转',
        content: [
          '员工信息收集表搭建',
          '人事合同自定义台账',
          '薪资信息保密',
          '人事信息与EHR系统互连',
          '合同批量发签',
          '合同批量发签',
          '合同批量发签',
          '······',
        ],
      },
      changjing: {
        title: '覆盖人事几大场景',
        content: [
          {
            img: require('../../assets/images/landing-contractmanage/personnel-one.png'),
            text: 'offer发放',
          },
          {
            img: require('../../assets/images/landing-contractmanage/personnel-two.png'),
            text: '员工信息收集',
          },
          {
            img: require('../../assets/images/landing-contractmanage/personnel-three.png'),
            text: '劳动合同签订&续签 ',
          },
          {
            img: require('../../assets/images/landing-contractmanage/personnel-four.png'),
            text: '转岗调岗协议签订',
          },
          {
            img: require('../../assets/images/landing-contractmanage/personnel-five.png'),
            text: '内部证明开具',
          },
          {
            img: require('../../assets/images/landing-contractmanage/personnel-six.png'),
            text: '数据同步EHR系统建档',
          },
        ],
      },
    },
    {
      td: {
        title: '分销痛点',
        content: [
          {
            key: 5,
            desc: '经销商遍布全国各地\n异地签约效率低',
          },
          {
            key: 6,
            desc: '合同经常变更解约麻烦',
          },
          {
            key: 7,
            desc: '合同是履约的重要凭证\n履约信息获取难',
          },
          {
            key: 8,
            desc: '经销商资质经常变更\n风险难管控',
          },
        ],
      },
      fa: {
        title: '分销解决方案',
        text: '基于分销场景为企业提供如下能力，助力企业分销场景跨系统高效签管，体现合同全链路价值',
        content: [
          '经销商风控管理',
          '经销合同自动分类归档',
          '经销合同内容审批',
          '经销合同自定义台账',
          '智能比对',
          '数据同步业务系统',
          '分子公司管理',
          '······',
        ],
      },
      changjing: {
        title: '覆盖分销几大场景',
        content: [
          {
            img: require('../../assets/images/landing-contractmanage/distribution-one.png'),
            text: '经销商风险审查',
          },
          {
            img: require('../../assets/images/landing-contractmanage/distribution-two.png'),
            text: '经销商合作协议签订',
          },
          {
            img: require('../../assets/images/landing-contractmanage/distribution-three.png'),
            text: '物流单对账单签订',
          },
          {
            img: require('../../assets/images/landing-contractmanage/distribution-four.png'),
            text: '业务履约信息提取',
          },
          {
            img: require('../../assets/images/landing-contractmanage/distribution-five.png'),
            text: '业务数据跟进',
          },
          {
            img: require('../../assets/images/landing-contractmanage/distribution-six.png'),
            text: '业务数据同步业务系统履约',
          },
        ],
      },
    },
  ],
}
